export default "__VITE_ASSET__DFNU8QPG__"